import { Button } from './Button'
import { RootState } from 'constants/interfaces'
import React from 'react'
import { useSelector } from 'react-redux'
import { Spinner, Text } from '@chakra-ui/core'

interface Props {
  isLoading: boolean
  onClick?: () => void
  icon: React.ReactNode
  btnText: string
  isDataFetching?: boolean
}
export const DashboardMenuButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ isLoading, onClick, icon, btnText, isDataFetching, ...props }, ref) => {
    const theme = useSelector((state: RootState) => state?.general?.theme)
    return (
      <Button
        ref={ref}
        type="button"
        isDisabled={isLoading}
        color="white"
        borderRadius="10px"
        bg={theme?.elementsColor}
        cursor={isLoading ? 'not-allowed' : 'pointer'}
        pointerEvents={isLoading ? 'none' : 'auto'}
        style={{ columnGap: '10px' }}
        opacity={isLoading ? 0.4 : 1}
        _hover={{ opacity: 0.6, bg: theme?.elementsColor }}
        _focus={{ boxShadow: 'none' }}
        onClick={onClick}
        {...props}
      >
        <Text>{btnText}</Text>
        {isDataFetching ? <Spinner size="sm" /> : icon}
      </Button>
    )
  }
)
